import { useAnyPlayerActive } from '@/hooks/media/useAnyPlayerActive';
import { cn } from '@/lib/utils';
import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';
import { useBoardsContext } from './context-provider';
import { BoardsPopup } from './popup';
export const BoardsPopupContainer = () => {
  const {
    boardsPopupIsOpen,
    asset
  } = useBoardsContext();
  const playerIsOpen = useAnyPlayerActive();

  // Pass a key to the boards popup so the timebar animation resets when assets are rapidly added to boards
  const popupKey = useMemo(() => {
    if (asset) {
      return asset.data.id;
    }
  }, [asset]);
  return <div className={cn('pointer-events-none fixed inset-0 z-30 flex h-dvh w-dvw items-end justify-end transition-all duration-300 ease-out-circ', 'pr-12', playerIsOpen ? 'pb-20' : 'pb-8')} data-sentry-component="BoardsPopupContainer" data-sentry-source-file="popup-container .tsx">
      <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="popup-container .tsx">
        {!!boardsPopupIsOpen && <motion.div animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        transition: {
          ease: 'easeIn',
          duration: 0.16
        }
      }} initial={{
        opacity: 0,
        y: 20
      }} key="boards-popup" transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }}>
            <BoardsPopup key={popupKey} />
          </motion.div>}
      </AnimatePresence>
    </div>;
};